module.exports = __webpack_public_path__ + "img/person3.e3c2ef8d.png";